import { render, staticRenderFns } from "./UserPreview.vue?vue&type=template&id=6a76c0c1&scoped=true"
import script from "./UserPreview.vue?vue&type=script&lang=js"
export * from "./UserPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPreview.vue?vue&type=style&index=0&id=6a76c0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76c0c1",
  null
  
)

export default component.exports